import { z } from "zod";

export const forgotPasswordSchema = z.object({
  email: z.string().refine((val) => /\S+@\S+\.\S+/.test(val), {
    message: "Please enter a valid email address",
  }),
});

export type ForgotPasswordFormSchema = z.infer<typeof forgotPasswordSchema>;
